import { render, staticRenderFns } from "./Brand_Reputation.vue?vue&type=template&id=6b62b1a0&scoped=true&"
import script from "./Brand_Reputation.vue?vue&type=script&lang=js&"
export * from "./Brand_Reputation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b62b1a0",
  null
  
)

export default component.exports